import classNames from 'classnames'
import React, {memo} from 'react'

import Icon from '../../../../../common/Icon/Icon'
import SvgIcon from '../../../../../common/SvgIcon/SvgIcon'

import type {JobIconStatusProps} from './JobIconStatus.types'

import styles from './JobIconStatus.css'

function JobIconStatus({icon, parallelized, status, className}: JobIconStatusProps) {
  const isError = status?.toLowerCase() === 'failure'
  const isSuccess = status?.toLowerCase() === 'success'
  const iconsWrapperClassName = classNames(styles.iconsWrapper, className)
  const parallelismIconClassName = classNames(styles.parallelismIcon, {
    [styles.parallelismIconSuccess]: isSuccess,
    [styles.parallelismIconError]: isError,
  })

  return (
    <span className={iconsWrapperClassName}>
      <Icon className={styles.icon} name={icon} />
      {parallelized && <SvgIcon className={parallelismIconClassName} icon="stack" />}
    </span>
  )
}

export default memo(JobIconStatus)
